var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curator_apply_wrap"},[_c('div',{staticClass:"curator_apply_title"},[_vm._v(" "+_vm._s(_vm.$t('curator_apply1'))+" ")]),_c('curation-application-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }